<div class="buttonsHolder">
    <ui-icon-button [title]="'Open disclosure to edit and submit'" [disabled]="false" [color]="'BLUE' | iconButtonColorEnumPipe" [iconName]="'icon-circle-edit'" [heightInPx]="'25px'" [widthInPx]="'25px'" [screenReaderText]="'Open'" (click)="open()"></ui-icon-button>
    <button [title]="'Rollback disclosure being amended to the previous submitted version'" uiLibButton
            [color]="'PRIMARY' | buttonColorEnumPipe"
            [size]="'SMALL' | buttonSizeEnumPipe"
            [shape]="'ROUNDED' | buttonShapeEnumPipe"
            (click)="rollback()">
      Rollback
    </button>
  </div>